// React Imports
import React, { Component } from "react";

export default class NotFoundDetail extends Component {
    render() {
        return <div className="four-oh-four">
            <div className="number">404</div>
            Page not found
            <div><a href="/">Click here to return home</a></div>
        </div>;
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/NotFoundDetail.js
 **/